export default __webpack_public_path__ + "static/media/Copy of 06-upgrade-your-system.3bc195c4.jpg";